/** recoil persist key  */
export const RECOIL_PERSIST_KEY = "routine-care-recoil-persist";

export const ACCESS_TOKEN = "routine-care-access-token";
export const REFRESH_TOKEN = "routine-care-refresh-token";
